(() => {
  const WISHLIST_KEY = 'reevys:wishlist:v1';
  const SIZE_PROFILE_KEY = 'reevys:size-profile:v1';
  const PRODUCT_MAIN = 'main[data-template*="product"]';
  const COLOR_WORDS = ['color', 'colour', 'cor', 'couleur', 'farbe', 'colore'];
  const SIZE_WORDS = ['size', 'tamanho', 'taille', 'gr��e', 'groesse', 'taglia', 'talla'];

  const BASELINE = [
    { size: 'XXS', bust: 82, waist: 64, hips: 88 },
    { size: 'XS',  bust: 86, waist: 68, hips: 92 },
    { size: 'S',   bust: 90, waist: 72, hips: 96 },
    { size: 'M',   bust: 94, waist: 76, hips: 100 },
    { size: 'L',   bust: 100, waist: 82, hips: 106 },
    { size: 'XL',  bust: 106, waist: 88, hips: 112 },
    { size: 'XXL', bust: 112, waist: 94, hips: 118 },
    { size: '3XL', bust: 118, waist: 100, hips: 124 }
  ];

  const colorMap = {
    black: '#171716', white: '#f4f3ef', ivory: '#efe9dd', cream: '#eadfc9',
    beige: '#d5c5a9', khaki: '#9a9277', tan: '#b78c67', camel: '#ae835e',
    brown: '#63432f', chocolate: '#3f291f', coffee: '#5b4031', grey: '#bebfbd', gray: '#bebfbd',
    charcoal: '#4d4f4d', blue: '#5d7898', navy: '#273142', denim: '#6b8098',
    red: '#9a2928', wine: '#5c2430', burgundy: '#5a2632', pink: '#ddb2bb', blush: '#e4c2c2',
    green: '#66765e', olive: '#74764f', sage: '#9da88f', yellow: '#d9bb57', butter: '#e8d99c',
    orange: '#c87945', purple: '#88709a', lilac: '#c3b1d0', silver: '#bfc0c0', gold: '#b09259'
  };

  const debounce = (fn, wait = 80) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), wait);
    };
  };

  function parseConfig() {
    const nodes = document.querySelectorAll('[data-reevys-pdp-config]');
    const node = nodes[nodes.length - 1];
    if (!node) return null;
    try {
      const config = JSON.parse(node.textContent);
      for (const key of Object.keys(config.sizeCopy || {})) {
        config.sizeCopy[key] = new DOMParser().parseFromString(config.sizeCopy[key], 'text/html').body.textContent;
      }
      return config;
    } catch (error) { return null; }
  }

  function productRoot() {
    return document.querySelector(`${PRODUCT_MAIN} .product-details`) || document.querySelector('[data-testid="product-information-details"]');
  }

  function cleanName(value = '') {
    return value.trim().toLowerCase().replace(/[::]/g, '');
  }

  function optionName(select) {
    const match = (select.getAttribute('name') || '').match(/options\[(.*?)\]/i);
    if (match) return cleanName(match[1]);
    const label = select.closest('.variant-option')?.querySelector('label');
    return cleanName(label?.textContent || '');
  }

  function isColorName(name) { return COLOR_WORDS.some(word => name === word || name.includes(word)); }
  function isSizeName(name) { return SIZE_WORDS.some(word => name === word || name.includes(word)); }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function currentSelections(root) {
    return [...root.querySelectorAll('select.variant-option__select')].map(select => select.value);
  }

  function currentVariant(config, root) {
    if (!config?.variants?.length) return null;
    const formVariantId = root.querySelector('product-form-component input[name="id"]')?.value;
    const formVariant = config.variants.find(variant => String(variant.id) === String(formVariantId));
    if (formVariant) return formVariant;
    const selections = currentSelections(root);
    if (selections.length) {
      const exact = config.variants.find(variant =>
        Array.isArray(variant.options) && variant.options.length >= selections.length &&
        selections.every((value, index) => String(variant.options[index]) === String(value))
      );
      if (exact) return exact;
    }
    return config.variants.find(variant => String(variant.id) === String(config.currentVariantId)) || config.variants[0];
  }

  function colorFor(value) {
    const normalized = cleanName(value);
    for (const [token, hex] of Object.entries(colorMap)) {
      if (normalized.includes(token)) return hex;
    }
    return '#dededb';
  }

  function shouldUseImage(value) {
    return /(print|printed|stripe|striped|plaid|check|checked|floral|flower|multi|pattern|zebra|leopard|animal|dot|polka|ombre|tie[- ]?dye)/i.test(value);
  }

  function variantForOption(config, index, value) {
    return config.variants?.find(variant => Array.isArray(variant.options) && String(variant.options[index]) === String(value)) || null;
  }

  function enhanceHeader(root, config) {
    // IMPORTANT: select the nested title/price group, never the outer PDP group.
    // The previous direct-child :scope selector matched the entire outer group,
    // causing injected subtitle metadata to become a sibling of the PDP content.
    const header =
      root.querySelector(':scope > .group-block > .group-block-content > .group-block:has(> .group-block-content > product-price)') ||
      root.querySelector('.group-block-content:has(> product-price)')?.parentElement;

    // Remove any stale bad injection if this function runs after a dynamic section refresh.
    root.querySelectorAll(':scope > .reevys-pdp-meta[data-reevys-injected="meta"]').forEach(node => node.remove());

    if (!header || header.dataset.reevysHeaderEnhanced === 'true') return;
    header.dataset.reevysHeaderEnhanced = 'true';

    const values = [config.subtitle, config.badge, config.moreFabricsText].filter(Boolean);
    if (!values.length) return;

    const meta = document.createElement('div');
    meta.className = 'reevys-pdp-meta';
    meta.dataset.reevysInjected = 'meta';
    if (config.subtitle) {
      const p = document.createElement('p');
      p.className = 'reevys-pdp-subtitle';
      p.textContent = config.subtitle;
      meta.appendChild(p);
    }
    if (config.badge) {
      const badge = document.createElement('span');
      badge.className = 'reevys-pdp-badge';
      badge.textContent = config.badge;
      meta.appendChild(badge);
    }
    if (config.moreFabricsText) {
      const p = document.createElement('p');
      p.className = 'reevys-pdp-fabrics';
      p.append('More fabrics include ');
      const value = document.createElement('span');
      value.textContent = config.moreFabricsText;
      p.appendChild(value);
      p.append('.');
      meta.appendChild(p);
    }
    header.insertAdjacentElement('afterend', meta);
  }

  function enhanceColor(option, select, config, root) {
    if (option.hasAttribute('data-reevys-server-option')) return;
    option.classList.add('reevys-color-option');
    const nativeLabel = option.querySelector(':scope > label');
    const nativeControl = option.querySelector(':scope > .variant-option__select-wrapper');
    nativeLabel?.classList.add('reevys-native-color-label');
    nativeControl?.classList.add('reevys-native-color-control');

    let ui = option.querySelector(':scope > .reevys-pdp-color-ui');
    if (!ui) {
      ui = document.createElement('div');
      ui.className = 'reevys-pdp-color-ui';
      const head = document.createElement('div');
      head.className = 'reevys-pdp-color-head';
      head.innerHTML = '<span>Color <span class="reevys-pdp-color-value"></span></span><span class="reevys-pdp-style-code"></span>';
      const swatches = document.createElement('div');
      swatches.className = 'reevys-pdp-color-swatches';
      swatches.setAttribute('role', 'radiogroup');
      swatches.setAttribute('aria-label', 'Color');
      ui.append(head, swatches);
      option.insertBefore(ui, nativeControl || null);
    }

    const selects = [...root.querySelectorAll('select.variant-option__select')];
    const optionIndex = selects.indexOf(select);
    const swatches = ui.querySelector('.reevys-pdp-color-swatches');
    const signature = [...select.options].map(o => `${o.value}:${o.textContent}`).join('|');
    if (swatches.dataset.signature !== signature) {
      swatches.innerHTML = '';
      swatches.dataset.signature = signature;
      [...select.options].forEach(nativeOption => {
        const value = nativeOption.value;
        const variant = variantForOption(config, optionIndex, value);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'reevys-pdp-swatch';
        button.dataset.value = value;
        button.dataset.unavailable = /unavailable|sold out/i.test(nativeOption.textContent) ? 'true' : 'false';
        button.setAttribute('aria-label', value);
        button.setAttribute('title', value);
        button.style.setProperty('--reevys-swatch-color', colorFor(value));
        if (variant?.image && shouldUseImage(value)) {
          button.style.setProperty('--reevys-swatch-image', `url("${variant.image}")`);
        }
        button.addEventListener('click', () => {
          if (select.value === value) return;
          select.value = value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(() => sync(root, config), 20);
        });
        swatches.appendChild(button);
      });
    }
  }

  function enhanceSize(option, select, config) {
    if (option.hasAttribute('data-reevys-server-option')) return;
    option.classList.add('reevys-size-option');
    const nativeLabel = option.querySelector(':scope > label');
    nativeLabel?.classList.add('reevys-native-size-label');
    const nativeControl = option.querySelector(':scope > .variant-option__select-wrapper');
    if (!nativeControl || option.querySelector(':scope > .reevys-pdp-size-tools')) return;

    if (config.modelInfo) {
      const p = document.createElement('p');
      p.className = 'reevys-pdp-model';
      p.textContent = config.modelInfo;
      option.insertBefore(p, nativeControl);
    }
    if (config.fitNote) {
      const p = document.createElement('p');
      p.className = 'reevys-pdp-fit-note';
      p.textContent = config.fitNote;
      option.insertBefore(p, nativeControl);
    }

    const tools = document.createElement('div');
    tools.className = 'reevys-pdp-size-tools';
    tools.innerHTML = '<button type="button" class="reevys-pdp-size-tool" data-reevys-find-size>Find Your Size</button><button type="button" class="reevys-pdp-size-tool" data-reevys-size-chart>Size Chart</button>';
    option.insertBefore(tools, nativeControl);
  }

  function enhanceVariants(root, config) {
    root.querySelectorAll('.variant-option--dropdowns').forEach(option => {
      const select = option.querySelector('select.variant-option__select');
      if (!select) return;
      const name = optionName(select);
      if (isColorName(name)) enhanceColor(option, select, config, root);
      if (isSizeName(name)) enhanceSize(option, select, config);
    });
  }


  function wishlistRead() {
    try {
      const parsed = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) { return []; }
  }

  function wishlistWrite(items) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (error) {}
  }

  function wishlistHas(config) {
    return wishlistRead().some(item => String(item.id) === String(config.productId));
  }

  function updateWishlistButton(button, config) {
    const active = wishlistHas(config);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Save to wishlist');
    button.title = button.getAttribute('aria-label');
  }

  function toggleWishlist(button, config) {
    const items = wishlistRead();
    const index = items.findIndex(item => String(item.id) === String(config.productId));
    if (index >= 0) items.splice(index, 1);
    else items.unshift({ id: config.productId, handle: config.handle, title: config.title, url: config.url, image: config.image, addedAt: Date.now() });
    wishlistWrite(items);
    updateWishlistButton(button, config);
    window.dispatchEvent(new CustomEvent('reevys:wishlist:change', { detail: { count: items.length, items } }));
  }

  function enhanceBuy(root, config) {
    const buttons = root.querySelector('.product-form-buttons');
    const add = buttons?.querySelector('button[name="add"]');
    if (!buttons || !add) return;

    const gallery = root.closest('.shopify-section')?.querySelector('media-gallery');
    let wishlist = gallery?.querySelector(':scope > .reevys-wishlist-button') || buttons.querySelector(':scope > .reevys-wishlist-button');
    if (!wishlist) {
      wishlist = document.createElement('button');
      wishlist.type = 'button';
      wishlist.className = 'reevys-wishlist-button';
      wishlist.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.75 4.75A1.75 1.75 0 0 1 8.5 3h7A1.75 1.75 0 0 1 17.25 4.75v15.1L12 16.55l-5.25 3.3V4.75Z"/></svg>';
      wishlist.addEventListener('click', () => toggleWishlist(wishlist, config));
    }
    const target = gallery || buttons;
    if (wishlist.parentElement !== target) target.prepend(wishlist);
    buttons.classList.toggle('reevys-has-wishlist', !gallery);
    buttons.classList.toggle('reevys-has-gallery-wishlist', Boolean(gallery));
    updateWishlistButton(wishlist, config);
  }

  function enhanceStory(root, config) {
    if (root.querySelector('reevys-product-info')) return;
    if (!config.whyItWorks || root.querySelector('.reevys-pdp-story')) return;
    const accordion = root.querySelector('.accordion');
    const story = document.createElement('section');
    story.className = 'reevys-pdp-story';
    const h2 = document.createElement('h2');
    h2.textContent = 'Why it works';
    const p = document.createElement('p');
    p.textContent = config.whyItWorks;
    story.append(h2, p);
    if (accordion) accordion.insertAdjacentElement('beforebegin', story);
    else root.appendChild(story);
  }

  function sync(root, config) {
    const variant = currentVariant(config, root);
    const size = root.querySelector('[data-reevys-size-select]');
    const pending = Boolean(size && !size.value);
    const picker = size?.closest('variant-picker');
    const selectLabel = picker?.dataset.reevysSelectSize || size?.querySelector('[data-reevys-size-placeholder]')?.textContent;
    root.classList.toggle('reevys-size-pending', pending);

    root.querySelectorAll('.reevys-color-option').forEach(option => {
      const select = option.querySelector('select.variant-option__select');
      const value = select?.value || '';
      setText(option.querySelector('.reevys-pdp-color-value'), value);
      option.querySelectorAll('.reevys-pdp-swatch').forEach(button => {
        button.setAttribute('aria-pressed', button.dataset.value === value ? 'true' : 'false');
      });
      const codeNode = option.querySelector('.reevys-pdp-style-code');
      const rawCode = config.styleCode || variant?.sku || '';
      const displayCode = rawCode ? (String(rawCode).startsWith('#') ? String(rawCode) : `#${rawCode}`) : '';
      setText(codeNode, displayCode);
      if (codeNode) codeNode.hidden = !displayCode;
    });

    const add = root.querySelector('.product-form-buttons button[name="add"]');
    if (pending && add) add.disabled = true;
    if (add && (pending || (!add.disabled && variant?.price))) {
      let label = add.querySelector('.reevys-atc-label');
      if (!label) {
        label = document.createElement('span');
        label.className = 'reevys-atc-label';
        const added = add.querySelector('.add-to-cart__added');
        add.insertBefore(label, added || null);
      }
      setText(label, pending ? selectLabel : `Add to Bag - ${variant.price}`);
      add.setAttribute('aria-label', label.textContent);
      add.classList.add('reevys-atc-enhanced');
    } else if (add) {
      add.classList.remove('reevys-atc-enhanced');
      add.querySelector('.reevys-atc-label')?.remove();
      add.removeAttribute('aria-label');
    }

    const sticky = document.querySelector(`${PRODUCT_MAIN} sticky-add-to-cart`);
    if (sticky && pending) {
      setText(sticky.querySelector('.add-to-cart-text__content > span:first-child'), selectLabel);
      setText(sticky.querySelector('.sticky-add-to-cart__variant'), selectLabel);
    }
  }

  function sizeSelect(root) {
    return [...root.querySelectorAll('select.variant-option__select')].find(select => isSizeName(optionName(select))) || null;
  }

  function availableSizes(root) {
    const select = sizeSelect(root);
    if (!select) return [];
    return [...select.options]
      .filter(option => option.value && !option.disabled && !/unavailable|sold out/i.test(option.textContent))
      .map(option => option.value);
  }

  function normalizeSize(value = '') {
    const size = String(value).toUpperCase().replace(/[\s-]/g, '');
    if (size === '2XL') return 'XXL';
    if (size === 'XXXL') return '3XL';
    return size;
  }

  function sizeFields(config = parseConfig()) {
    const title = String(config?.title || config?.productType || '').toLowerCase();
    if (/\b(set|dress|gown|jumpsuit|romper|bodysuit)\b|two-piece|co-ord/.test(title)) return ['bust', 'waist', 'hips'];
    if (/\b(shorts?|skorts?|skirts?|pants|trousers|jeans|leggings)\b/.test(title)) return ['waist', 'hips'];
    if (/\b(tops?|shirts?|t-shirts?|blouses?|tanks?|tees?|sweaters?|cardigans?|blazers?|jackets?|coats?)\b/.test(title)) return ['bust', 'waist'];
    if (/\b(shoes?|boots?|sandals?|heels?|bags?|totes?|clutch|earrings?|necklace|bracelet|ring|belt)\b/.test(title)) return [];
    return ['bust', 'waist', 'hips'];
  }

  function recommendSize(root, values, unit, config = parseConfig()) {
    const copy = config.sizeCopy;
    const fields = sizeFields(config);
    const measurements = {};
    fields.forEach(key => {
      const number = Number(values[key]);
      if (Number.isFinite(number) && number > 0) measurements[key] = unit === 'in' ? number * 2.54 : number;
    });
    if (!fields.length) return { error: copy.unsupported };
    if (Object.keys(measurements).length !== fields.length) return { error: copy.required };

    // Unit buttons round to 0.1 inches; allow that rounding without moving up a size.
    const row = BASELINE.find(candidate => Object.entries(measurements).every(([key, value]) => value <= candidate[key] + 0.15));
    if (!row || fields.some(key => measurements[key] < BASELINE[0][key] - 6)) return { error: copy.out_of_range };

    const available = availableSizes(root);
    if (!available.length) return { error: copy.unavailable };
    const normalizedAvailable = available.map(value => ({ value, normalized: normalizeSize(value) }));
    if (!normalizedAvailable.some(item => BASELINE.some(base => base.size === item.normalized))) {
      return { error: copy.different_system };
    }

    const resolved = normalizedAvailable.find(item => item.normalized === row.size);
    if (!resolved) return { error: copy.unavailable };
    return { size: resolved.value };
  }

  function readProfile() {
    try { return JSON.parse(localStorage.getItem(SIZE_PROFILE_KEY) || '{}') || {}; } catch (error) { return {}; }
  }

  function writeProfile(profile) {
    try { localStorage.setItem(SIZE_PROFILE_KEY, JSON.stringify(profile)); } catch (error) {}
  }

  function ensureSizeDialog(root) {
    let dialog = document.getElementById('reevys-size-finder');
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.id = 'reevys-size-finder';
    dialog.className = 'reevys-size-dialog';
    dialog.setAttribute('aria-labelledby', 'reevys-size-title');
    dialog.innerHTML = `
      <div class="reevys-size-dialog__inner">
        <div class="reevys-size-dialog__head">
          <h2 id="reevys-size-title" data-reevys-size-title>Find Your Size</h2>
          <button type="button" class="reevys-size-dialog__close" aria-label="Close">&times;</button>
        </div>
        <div data-reevys-finder-view>
          <p class="reevys-size-dialog__intro">Enter the body measurements you normally use when shopping. We'll give you a best starting point, then you can compare it with this item's product measurements.</p>
          <div class="reevys-size-unit" role="group" aria-label="Measurement unit">
            <button type="button" data-unit="cm" aria-pressed="true">CM</button>
            <button type="button" data-unit="in" aria-pressed="false">IN</button>
          </div>
          <div class="reevys-size-fields">
            <div class="reevys-size-field"><label for="reevys-size-bust">Bust</label><input id="reevys-size-bust" inputmode="decimal" type="number" min="1" step="0.1"></div>
            <div class="reevys-size-field"><label for="reevys-size-waist">Waist</label><input id="reevys-size-waist" inputmode="decimal" type="number" min="1" step="0.1"></div>
            <div class="reevys-size-field"><label for="reevys-size-hips">Hips</label><input id="reevys-size-hips" inputmode="decimal" type="number" min="1" step="0.1"></div>
          </div>
          <button type="button" class="reevys-size-find">Find my size</button>
          <div class="reevys-size-result" aria-live="polite"></div>
          <button type="button" class="reevys-size-chart-link" data-reevys-dialog-chart>View Size Chart</button>
          <p class="reevys-size-note">This is directional fit guidance, not a guarantee. Product measurements in Size Chart remain the best reference for the individual garment.</p>
        </div>
        <div data-reevys-chart-view hidden>
          <p class="reevys-size-dialog__intro">REEVYS body-size baseline. Measurements are in centimeters.</p>
          <table class="reevys-generic-chart">
            <thead><tr><th>Size</th><th>Bust</th><th>Waist</th><th>Hips</th></tr></thead>
            <tbody>${BASELINE.map(row => `<tr><td>${row.size}</td><td>? ${row.bust}</td><td>? ${row.waist}</td><td>? ${row.hips}</td></tr>`).join('')}</tbody>
          </table>
          <button type="button" class="reevys-size-chart-link" data-reevys-dialog-finder>Back to Find Your Size</button>
          <p class="reevys-size-note">When a product-specific measurement table is available, REEVYS shows that instead of this general body-size baseline.</p>
        </div>
      </div>`;
    document.body.appendChild(dialog);

    const profile = readProfile();
    let unit = profile.unit === 'in' ? 'in' : 'cm';
    ['bust', 'waist', 'hips'].forEach(key => {
      if (profile[key]) dialog.querySelector(`#reevys-size-${key}`).value = profile[key];
    });

    const syncUnit = () => {
      dialog.querySelectorAll('[data-unit]').forEach(button => button.setAttribute('aria-pressed', button.dataset.unit === unit ? 'true' : 'false'));
    };
    const clearResult = () => {
      const result = dialog.querySelector('.reevys-size-result');
      result.textContent = '';
      result.dataset.visible = 'false';
    };
    dialog.querySelectorAll('.reevys-size-field input').forEach(input => input.addEventListener('input', clearResult));
    syncUnit();
    dialog.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
      const nextUnit = button.dataset.unit;
      if (nextUnit === unit) return;
      dialog.querySelectorAll('.reevys-size-field input').forEach(input => {
        const value = Number(input.value);
        if (input.value.trim() && Number.isFinite(value) && value > 0) {
          input.value = String(Math.round((nextUnit === 'in' ? value / 2.54 : value * 2.54) * 10) / 10);
        }
      });
      unit = nextUnit;
      const result = dialog.querySelector('.reevys-size-result');
      result.textContent = '';
      result.dataset.visible = 'false';
      syncUnit();
    }));
    dialog.querySelector('.reevys-size-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.querySelector('.reevys-size-find').addEventListener('click', () => {
      const values = {
        bust: dialog.querySelector('#reevys-size-bust').value,
        waist: dialog.querySelector('#reevys-size-waist').value,
        hips: dialog.querySelector('#reevys-size-hips').value
      };
      writeProfile({ unit, ...values });
      const config = parseConfig();
      const recommendation = recommendSize(productRoot() || root, values, unit, config);
      const result = dialog.querySelector('.reevys-size-result');
      result.replaceChildren();
      if (recommendation.error) result.textContent = recommendation.error;
      else {
        const heading = document.createElement('strong');
        heading.textContent = config.sizeCopy.result.replace('{size}', recommendation.size);
        result.append(heading, document.createTextNode(config.sizeCopy.result_note));
      }
      result.dataset.visible = 'true';
    });
    dialog.querySelector('[data-reevys-dialog-chart]').addEventListener('click', () => {
      dialog.close();
      openChart(productRoot() || root);
    });
    dialog.querySelector('[data-reevys-dialog-finder]').addEventListener('click', () => showDialogView(dialog, 'finder'));
    return dialog;
  }

  function showDialogView(dialog, view) {
    const finder = dialog.querySelector('[data-reevys-finder-view]');
    const chart = dialog.querySelector('[data-reevys-chart-view]');
    const title = dialog.querySelector('[data-reevys-size-title]');
    const chartMode = view === 'chart';
    finder.hidden = chartMode;
    chart.hidden = !chartMode;
    title.textContent = chartMode ? 'Size Chart' : 'Find Your Size';
  }

  function openFinder(root) {
    const dialog = ensureSizeDialog(root);
    const config = parseConfig();
    const fields = sizeFields(config);
    const copy = config.sizeCopy;
    const view = dialog.querySelector('[data-reevys-finder-view]');
    const intro = fields.length === 3 ? 'full_intro' : fields.includes('hips') ? 'bottoms_intro' : 'tops_intro';
    view.querySelector('.reevys-size-dialog__intro').textContent = copy[fields.length ? intro : 'unsupported'];
    view.querySelector('.reevys-size-note').textContent = copy.note;
    view.querySelector('.reevys-size-fields').style.setProperty('--size-field-count', fields.length || 1);
    view.querySelector('.reevys-size-unit').hidden = !fields.length;
    view.querySelector('.reevys-size-find').hidden = !fields.length;
    ['bust', 'waist', 'hips'].forEach(key => {
      const input = dialog.querySelector(`#reevys-size-${key}`);
      const field = input.closest('.reevys-size-field');
      field.hidden = !fields.includes(key);
      field.querySelector('label').textContent = copy[key];
      let hint = field.querySelector('small');
      if (!hint) {
        hint = document.createElement('small');
        hint.id = `reevys-size-${key}-hint`;
        field.appendChild(hint);
        input.setAttribute('aria-describedby', hint.id);
      }
      hint.textContent = copy[`${key}_hint`];
    });
    const result = dialog.querySelector('.reevys-size-result');
    result.textContent = '';
    result.dataset.visible = 'false';
    showDialogView(dialog, 'finder');
    if (!dialog.open) dialog.showModal();
  }

  function openChart(root) {
    const info = root.querySelector('reevys-product-info');
    if (info?.openChart?.(document.activeElement)) return;
    const productSpecific = root.querySelector('.reevys-pm-trigger');
    if (productSpecific) {
      productSpecific.click();
      return;
    }
    const dialog = ensureSizeDialog(root);
    showDialogView(dialog, 'chart');
    if (!dialog.open) dialog.showModal();
  }

  function bindToolClicks(root) {
    if (root.dataset.reevysToolClicks === 'true') return;
    root.dataset.reevysToolClicks = 'true';
    root.addEventListener('click', event => {
      const color = event.target.closest('[data-reevys-color-choice]');
      if (color) {
        const select = color.closest('.variant-option')?.querySelector('select');
        if (select && select.value !== color.dataset.value) {
          select.value = color.dataset.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          sync(root, parseConfig());
        }
        return;
      }
      const finder = event.target.closest('[data-reevys-find-size]');
      if (finder) { event.preventDefault(); openFinder(root); return; }
      const chart = event.target.closest('[data-reevys-size-chart]');
      if (chart) { event.preventDefault(); openChart(root); }
    });
  }

  function init() {
    const root = productRoot();
    const config = parseConfig();
    if (!root || !config) return;
    enhanceHeader(root, config);
    enhanceVariants(root, config);
    enhanceBuy(root, config);
    enhanceStory(root, config);
    bindToolClicks(root);
    sync(root, config);
  }

  const scheduleInit = debounce(init, 90);
  document.addEventListener('DOMContentLoaded', init, { once: true });
  document.addEventListener('change', event => {
    if (event.target.matches?.('select.variant-option__select')) queueMicrotask(init);
  }, true);
  document.addEventListener('shopify:section:load', scheduleInit);
  document.addEventListener('reevys:size-choice', init);
  window.addEventListener('pageshow', scheduleInit);

  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation => mutation.target.closest?.('.product-details') && (mutation.addedNodes.length || mutation.removedNodes.length))) init();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  init();
})();

